import styled from 'styled-components';

const RowStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.columns || 1}, 1fr);
  gap: 16px;
  margin-bottom: 16px;
`;

export default function Row({ columns, children }) {
  return <RowStyled columns={columns}>{children}</RowStyled>;
}